export const APP_LIGHT_MODE = 'light';
export const APP_DARK_MODE = 'dark';
export const SPACING_BASE_UNIT = 8;
export const LAYOUT_PADDING = 8;
export const DRAWER_WIDTH = 382;
export const SETTINGS_SUBHEADER_DESKTOP_MARGIN_BOTTOM = 2;
export const SETTINGS_SUBHEADER_TABLET_MOBILE_MARGIN_BOTTOM = 1;
export const SETTINGS_ITEM_MAX_WIDTH = '476px';

// Resource Library Card dimensions
export const RESOURCE_LIBRARY_CARD_WIDTH_MOBILE = 155;
export const RESOURCE_LIBRARY_CARD_WIDTH_TABLET = 170;
export const RESOURCE_LIBRARY_CARD_IMAGE_HEIGHT_MOBILE = 115;
export const RESOURCE_LIBRARY_CARD_IMAGE_HEIGHT_TABLET = 127;
export const RESOURCE_LIBRARY_CARD_CONTENT_HEIGHT_MOBILE = 75;
export const RESOURCE_LIBRARY_CARD_CONTENT_HEIGHT_TABLET = 83;

/**
 * Grid2 column configuration for resource sections
 * Controls how many columns are available at each breakpoint to achieve:
 * - Mobile (xs): 4 columns → 2 cards per row (size=2, so 2/4 = 50%)
 * - Tablet (sm): 8 columns → 4 cards per row (size=2, so 2/8 = 25%)
 * - Desktop (md+): 10 columns → 5 cards per row (size=2, so 2/10 = 20%)
 */
/** For Infinite scroll how far before the list end (px) the next page starts loading on infinite scroll. */
export const NEXT_PAGE_LOAD_PADDING = '200px';

export const RESOURCE_LAYOUT_GRID_COLUMNS = {
  xs: 4,
  sm: 8,
  md: 10,
};

/**
 * Horizontal padding for resource section containers at each breakpoint
 */
export const RESOURCE_SECTION_PADDING = {
  xs: 2,
  sm: 3,
  md: 4,
};

// Fixed gutter between cards (matches `spacing={2}` on the resource section Grid2 containers).
const RESOURCE_SECTION_CARD_GUTTER = SPACING_BASE_UNIT * 2;

// Cards render at a fixed width, so the section must be capped at exactly the space the target
// cards-per-row + gutters + padding need - otherwise leftover width collects unevenly on the
// right instead of centering the row under its title.
const computeSectionMaxWidth = (cardsPerRow: number, cardWidth: number, paddingFactor: number) => {
  const cardsRowWidth = cardsPerRow * cardWidth + (cardsPerRow - 1) * RESOURCE_SECTION_CARD_GUTTER;
  const horizontalPadding = paddingFactor * SPACING_BASE_UNIT * 2;
  return `${cardsRowWidth + horizontalPadding}px`;
};

/**
 * Maximum width constraints for resource section containers.
 * - Mobile (xs): fits 2 cards (155px) per row
 * - Tablet (sm): fits 4 cards (170px) per row
 * - Desktop (md/lg): fits 5 cards (170px) per row
 */
export const RESOURCE_SECTION_MAX_WIDTH = {
  xs: computeSectionMaxWidth(
    RESOURCE_LAYOUT_GRID_COLUMNS.xs / 2,
    RESOURCE_LIBRARY_CARD_WIDTH_MOBILE,
    RESOURCE_SECTION_PADDING.xs,
  ),
  sm: computeSectionMaxWidth(
    RESOURCE_LAYOUT_GRID_COLUMNS.sm / 2,
    RESOURCE_LIBRARY_CARD_WIDTH_TABLET,
    RESOURCE_SECTION_PADDING.sm,
  ),
  md: computeSectionMaxWidth(
    RESOURCE_LAYOUT_GRID_COLUMNS.md / 2,
    RESOURCE_LIBRARY_CARD_WIDTH_TABLET,
    RESOURCE_SECTION_PADDING.md,
  ),
  lg: computeSectionMaxWidth(
    RESOURCE_LAYOUT_GRID_COLUMNS.md / 2,
    RESOURCE_LIBRARY_CARD_WIDTH_TABLET,
    RESOURCE_SECTION_PADDING.md,
  ),
};
